import { Component, OnInit, Renderer2 } from '@angular/core';
import { OpentokService } from "../../_services/opentok.service";
import { OrganizationService, StreamBoxService } from "../../_services/generatedServices";
import { StreamboxViewModel } from "../../_models/generatedModels";

@Component({
  selector: 'bxl-caption-server',
  templateUrl: 'caption-server.component.html',
})
export class CaptionServerComponent implements OnInit {
  initialized = false;
  audioInputs: OT.Device[];
  videoInputs: OT.Device[];
  session: OT.Session;

  public channel1Device: string;
  public channel2Device: string;
  public channel3Device: string;
  public channel4Device: string;
  public channel5Device: string;
  public channel6Device: string;
  public channel7Device: string;
  public channel8Device: string;
  public channel9Device: string;
  public channel10Device: string;
  public channel11Device: string;
  public channel12Device: string;
  public channel13Device: string;
  public channel14Device: string;
  public channel15Device: string;
  public channel16Device: string;
  public channel17Device: string;
   streamboxes: StreamboxViewModel[];

  constructor(private opentokService: OpentokService,  private streamboxService: StreamBoxService, private renderer: Renderer2) { }

  ngOnInit(): void {
    this.getDeviceList();


    this.streamboxService.getAllStreamboxes().subscribe(boxes => {
      // this.streamboxService.startCaptions(2).subscribe((result) => {
        this.streamboxes = boxes;
        this.initialized = true;
      // });
    });
  }


  getDeviceList() {
    console.log('device list');
    let currentIndex = 0;
    OT.getDevices((err, devices) => {
      this.audioInputs = devices.filter((device) => device.kind === 'audioInput');
      this.videoInputs = devices.filter((device) => device.kind === 'videoInput');
    });
  }




}
